import React from 'react';
import { ShoppingBag, Info } from 'lucide-react';
import { useAlert } from '../../../../context/AlertContext';

// Toggle that lets a business enable/disable direct ordering from the customer
// portal menu. When disabled, the portal shows the menu only (like the Free
// plan) — no cart, no "add to cart", no checkout. Persisted in the tenant
// `theme` JSON as `portalOrderingEnabled` (default: enabled).
const MenuOrderingSetting = ({ tenantData, handleUpdateField, canEdit }) => {
    const { showAlert } = useAlert();
    const savedValue = tenantData?.theme?.portalOrderingEnabled !== false;
    const [enabled, setEnabled] = React.useState(savedValue);
    const [saving, setSaving] = React.useState(false);

    React.useEffect(() => {
        setEnabled(tenantData?.theme?.portalOrderingEnabled !== false);
    }, [tenantData?.theme?.portalOrderingEnabled]);

    const handleToggle = async (e) => {
        const newValue = e.target.checked;
        setEnabled(newValue); // optimistic
        setSaving(true);
        try {
            await handleUpdateField(
                'theme.portalOrderingEnabled',
                newValue,
                newValue ? 'Enabled portal menu ordering' : 'Disabled portal menu ordering'
            );
        } catch (err) {
            console.error('Menu ordering toggle error:', err);
            setEnabled(!newValue); // revert on failure
            showAlert('Ayar kaydedilemedi. Lütfen tekrar deneyin.', 'error');
        } finally {
            setSaving(false);
        }
    };

    return (
        <section className="card glass">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1.25rem', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ padding: '8px', borderRadius: '12px', background: 'rgba(var(--primary-rgb), 0.1)', color: 'var(--primary)' }}>
                        <ShoppingBag size={24} />
                    </div>
                    <div>
                        <h2 style={{ fontSize: '1.25rem', fontWeight: 700 }}>Menüden Sipariş</h2>
                        <p style={{ fontSize: '0.875rem', color: 'var(--text-muted)', maxWidth: '520px' }}>
                            Müşterilerin dijital menüden doğrudan sipariş verebilmesini açıp kapatın.
                        </p>
                    </div>
                </div>
                <label className="switch" style={{ opacity: canEdit && !saving ? 1 : 0.6, pointerEvents: canEdit && !saving ? 'auto' : 'none', flexShrink: 0 }}>
                    <input
                        type="checkbox"
                        checked={enabled}
                        disabled={!canEdit || saving}
                        onChange={handleToggle}
                    />
                    <span className="slider"></span>
                </label>
            </div>

            <div style={{ display: 'flex', gap: '12px', padding: '16px', background: 'var(--bg-main)', borderRadius: '16px', border: '1px solid var(--border)', marginTop: '1.5rem', maxWidth: '100%' }}>
                <Info size={20} style={{ flexShrink: 0, marginTop: '2px', color: 'var(--primary)' }} />
                <div style={{ fontSize: '0.875rem', lineHeight: '1.5', color: 'var(--text-muted)' }}>
                    {enabled ? (
                        <>Müşteriler menüden ürünleri sepete ekleyip sipariş verebilir.</>
                    ) : (
                        <>Sipariş <b>kapalı</b>. Müşteriler yalnızca menüyü görüntüler; sepet ve "sepete ekle" gösterilmez, sipariş verilemez.</>
                    )}
                </div>
            </div>
        </section>
    );
};

export default MenuOrderingSetting;
